var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Facebook Icon",
    d: "M22.3214 0H2.67857C1.96817 0 1.28686 0.282206 0.784535 0.784536C0.282206 1.28687 0 1.96817 0 2.67857L0 22.3214C0 23.0318 0.282206 23.7131 0.784535 24.2155C1.28686 24.7178 1.96817 25 2.67857 25H10.3376V16.5006H6.82199V12.5H10.3376V9.45089C10.3376 5.9827 12.4023 4.06696 15.5647 4.06696C17.0792 4.06696 18.6629 4.33705 18.6629 4.33705V7.74107H16.918C15.1987 7.74107 14.6624 8.80804 14.6624 9.90234V12.5H18.5006L17.8867 16.5006H14.6624V25H22.3214C23.0318 25 23.7131 24.7178 24.2155 24.2155C24.7178 23.7131 25 23.0318 25 22.3214V2.67857C25 1.96817 24.7178 1.28687 24.2155 0.784536C23.7131 0.282206 23.0318 0 22.3214 0Z",
    fill: "#918E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.6b8ec48b3eda3999c4716d0ef3123c18.svg";
export { ForwardRef as ReactComponent };